import { useState } from 'react';

import Image from 'next/image';

import { Grid, Box, useMediaQuery } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import PropTypes from 'prop-types';

import { CircularProgressWithLabel } from '@/src/components/atoms';

const useStyles = makeStyles(theme => ({
  imgWrapper: {
    position: 'relative',
    width: 100,
    height: 100,
  },
  logoImg: {
    filter: 'grayscale(100%)',
    borderRadius: theme.shape.borderRadius,
    transition: theme.transitions.create('all', {
      duration: theme.transitions.duration.complex,
    }),
    '&:hover': {
      filter: 'grayscale(0%)',
    },
  },
}));

export default function PartnersCard({ className, partners = [], ...rest }) {
  const classes = useStyles();
  const theme = useTheme();

  const [loaded, setLoaded] = useState({});

  const isMd = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  });

  return (
    <div className={className} {...rest}>
      <Grid container spacing={isMd ? 4 : 2} justifyContent="space-between">
        {partners?.slice(0, 6).map(partner => (
          <Grid item container justifyContent="center" xs={6} sm={2} key={partner.slug}>
            <div className={classes.imgWrapper}>
              {partner.logo && !loaded[partner.slug] && (
                <Box display="flex" height="100%" alignItems="center" justifyContent="center">
                  <CircularProgressWithLabel size={50} />
                </Box>
              )}
              {partner.logo && (
                <Image
                  src={partner.logo}
                  alt={partner.name || partner.slug}
                  className={classes.logoImg}
                  layout="fill"
                  objectFit="contain"
                  quality={60}
                  onLoad={event =>
                    setLoaded(prevState => ({
                      ...prevState,
                      [partner.slug]: event.target.complete,
                    }))
                  }
                />
              )}
            </div>
          </Grid>
        ))}
      </Grid>
    </div>
  );
}

PartnersCard.propTypes = {
  className: PropTypes.string,
  partners: PropTypes.array,
};
